import React, {useEffect} from "react"
import homeLink from '../../../shared/utils/siteUrl'

import Header from '../../organisms/header/header'
import Footer from '../../organisms/footer/footer'

import '../../../shared/styles/index.scss'
import "./page-layout.scss"
import "../../../styles/index.scss"

export default function PageLayout({children, isMobile, setglobalSession}) {

  const clientId = process.env.ENVIRONMENT === 'PDN' ?
      process.env.CLIENT_ID_PDN
      :
      process.env.ENVIRONMENT === 'STG' ?
        process.env.CLIENT_ID_STG
        :
        process.env.CLIENT_ID_DEV;

  const cognitoGroup = process.env.ENVIRONMENT === 'PDN' ?
      process.env.COGNITO_GROUP_PDN
      :
      process.env.ENVIRONMENT === 'STG' ?
        process.env.COGNITO_GROUP_STG
        :
        process.env.COGNITO_GROUP_DEV;

  const SSO_URL = cognitoGroup +
      "/authorize?identity_provider=adfs&redirect_uri="
      + homeLink + "&response_type=TOKEN&client_id="
      + clientId + "&scope=email openid phone profile"

  useEffect(() => {
    if (localStorage.getItem("SESSION_INFO") === null) {
      if(process.env.ENVIRONMENT !== "LOCAL")
        window.location.href = SSO_URL;
    }else {
      setglobalSession(JSON.parse(localStorage.getItem("SESSION_INFO")))
    }
  }, [setglobalSession])

  return (
    <div className="f-portal-inngenio">
      <Header isMobile={isMobile}/>
      <div className="f-portal-inngenio__container">{children}</div>
      <Footer isMobile={isMobile}/>
    </div>
  )
}
